<div class="footer serviceFooter">
  <div class="margin-left">
    <div class="row">
      <div class="col-8">
        <div>
          <div class="text-color font-size-large">{{authoringContentData?.changeStickyFooter?.expServicesTotalTxt}}{{' : '}}{{currentServicesTotal | currency}}{{authoringContentData?.changeStickyFooter?.perMonth}}</div>
          <div class="text-color font-size-small">{{authoringContentData?.changeStickyFooter?.taxesAndFeesTxt}}</div>
          <div class="text-color font-size-small">{{authoringContentData?.changeStickyFooter?.prevServicesTotalTxt}}{{' : '}}{{previousServicesTotal | currency}}{{authoringContentData?.changeStickyFooter?.perMonth}}</div>
        </div>
      </div>
      <div class="col-2 row">
        <button class="btn btn-primary back-button" *ngIf="isReviewPage && !retry" (click)="goToChangeServicesPage()">{{authoringContentData?.changeStickyFooter?.backTxt}}</button>
        <button class="btn btn-primary back-button" *ngIf="isReviewPage && retry" (click)="goToChangeServicesPage()">{{authoringContentData?.changeStickyFooter?.cancelTxt}}</button>
      </div>
      <div class="col-2 row">
        <button class="btn btn-primary review-button" *ngIf="!retry" [class.disabled]="!isServiceChanged || (isSubmitReadOnly && isReviewPage)" [disabled]="!isServiceChanged || (isSubmitReadOnly && isReviewPage)"  (click)="submitServiceChanges()"  tabindex="0">{{isReviewPage ? authoringContentData?.changeStickyFooter?.submitChangesTxt : authoringContentData?.changeStickyFooter?.reviewChangesTxt}}</button>
        <button class="btn btn-primary back-button" *ngIf="retry" (click)="submitServiceChanges()"  tabindex="0">{{authoringContentData?.changeStickyFooter?.retryTxt}}</button>
      </div>
    </div>
  </div>
</div>
<ng-template #transactionError class="modal fade in" let-c="close" let-d="dismiss">

  <div class="modal-header justify-content-start">
    <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-15 errorIcon" alt="Transaction failed">
    <h4 class="modal-title mt-0" id="modal-basic-title">{{authoringContentData?.changeStickyFooter?.errorReviewChangeModalTitle}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()" tabindex="0">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row m-0">
      <div class="addGroup-label">
        <p>{{authoringContentData?.changeStickyFooter?.errorReviewChangeBodyTxt}}
        </p>
      </div>
    </div>
  </div>

</ng-template>
